import { render, staticRenderFns } from "./PreviewData.vue?vue&type=template&id=52d4cff4&scoped=true"
import script from "./PreviewData.vue?vue&type=script&lang=js"
export * from "./PreviewData.vue?vue&type=script&lang=js"
import style0 from "./PreviewData.vue?vue&type=style&index=0&id=52d4cff4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d4cff4",
  null
  
)

export default component.exports